import { render, staticRenderFns } from "./newBadgeDesign.vue?vue&type=template&id=4409389f&"
import script from "./newBadgeDesign.vue?vue&type=script&lang=js&"
export * from "./newBadgeDesign.vue?vue&type=script&lang=js&"
import style0 from "./newBadgeDesign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports